import type { Obra } from "@/features/stages/obra.ts";
import { useActiveContext } from "@/store/use-active-context.ts";
import { useObras } from "./use-obras.ts";

export function useActiveObra() {
	const query = useObras();
	const activeObraId = useActiveContext((state) => state.activeObraId);

	const obras = query.data ?? [];
	const obra: Obra | null = obras.find((o) => o.id === activeObraId) ?? null;

	return {
		obra,
		obras,
		isLoading: query.isPending,
		isError: query.isError,
		refetch: query.refetch,
	};
}
